import React, { Component } from 'react';
import Draggable from 'react-draggable';
import { Rnd } from "react-rnd";

import { MinimizeButton } from '../../.common/Buttons/Minimize/MinimizeButton';
import { MaximizeButton } from '../../.common/Buttons/Maximize/MaximizeButton';
import { CancelButton } from '../../.common/Buttons/Cancel/CancelButton';

//
import './DraggableWindow.css'

//圖片

export class DraggableWindow extends Component {
    constructor(props) {
        super(props)

        this.state = {
            opacity: false,
            width: this.props.width || '500px',
            height: this.props.height || '500px',
        }
    }

    render() {
        {/*< Draggable
                handle = ".draggableWindow__header"
        defaultPosition = { this.props.defaultPosition || { x: 200, y: 200 } }
        bounds = "parent"
        position = { this.props.position }
        grid = { [5, 5]}
        scale = { 1}
        onStart = { this.handleStart }
        onDrag = { this.handleDrag }
        onStop = { this.handleStop } >*/}
        {/*</Draggable >*/ }
        return (
            <Rnd
                dragHandleClassName="draggableWindow__header"
                default={this.props.defaultPosition || { x: 200, y: 200 }}
                size={{
                    width: this.state.width,
                    height: this.state.height,
                }}
                position={this.props.position}
                dragGrid={[5, 5]}
                scale={1}
                bounds="parent"
                onDragStart={this.handleStart}
                onDrag={this.handleDrag}
                onDragStop={this.handleStop}
                enableResizing={{
                    top: false,
                    right: true,
                    bottom: true,
                    left: true,
                    topRight: false,
                    bottomRight: true,
                    bottomLeft: true,
                    topLeft: false
                }}
                onResize={(e, direction, ref, delta, position) => {
                    if (this.props.handleResize) {
                        this.props.handleResize(ref.style.width, ref.style.height);
                    }

                    this.setState({
                        width: (ref.style.width),
                        height: (ref.style.height),
                    });
                }}
                style={{ display: this.props.isShow ? 'inline-block' : 'none' }}
            >
                <div className='draggableWindow noPrint'
                    style={{
                        opacity: this.state.opacity ? "0.6" : "1",
                        width: this.state.width || '500px',
                        height: this.state.height || '500px',
                    }}>
                    <div className='draggableWindow__header'>
                        <span className='draggableWindow__header__text'>
                            {this.props.header || this.header()}
                        </span>
                        <div className='draggableWindow__header__buttons'>
                            <MinimizeButton width={25} height={25} onClick={this.handleMinimize} />
                            {/* <MaximizeButton width={25} height={25} onClick={this.handleMaximize}/> */}
                            {this.props.header != "社會經濟資料" ? <CancelButton width={25} height={25} onClick={this.handleCancel} /> : null}
                        </div>
                    </div>
                    <div className='draggableWindow__content'>
                        {this.props.content || this.content()}
                    </div>
                </div>
            </Rnd >
        );
    }

    header() {
        return "標題"
    }

    content() {
        return (<div>配置內容</div>);
    }

    display = () => {
        return this.context
            .draggableWindowContext
            .layersMap
    }

    handleStart = () => {
        this.setState({
            opacity: true
        })
        this.props.handleStart && this.props.handleStart();
    };

    handleDrag = () => {
        this.props.handleDrag && this.props.handleDrag();
    }

    handleStop = () => {
        this.setState({
            opacity: false
        })
        this.props.handleStop && this.props.handleStop();
    };

    handleMinimize = () => {
        console.log("縮小");
        this.props.handleMinimize && this.props.handleMinimize();
    }

    handleMaximize = () => {
        console.log("放大");
        this.props.handleMaximize && this.props.handleMaximize();
    }

    handleCancel = () => {
        console.log("關閉");
        this.props.handleCancel && this.props.handleCancel();
    }
}